import { useQuery } from '@tanstack/react-query';
import { getServices, getServiceById } from '../apis/services';
import type { ServiceWithAnalytics } from '../apis/services';

export const serviceKeys = {
  all: ['services'] as const,
  lists: () => [...serviceKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...serviceKeys.lists(), filters ?? {}] as const,
  detail: (id: string) => [...serviceKeys.all, 'detail', id] as const,
};

/**
 * Hook to fetch service catalog (public)
 */
export function useServices(params?: { category?: string; isActive?: boolean }) {
  return useQuery<ServiceWithAnalytics[], Error>({
    queryKey: serviceKeys.list(params),
    queryFn: () => getServices(params),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Hook to fetch a single service by ID
 */
export function useService(id: string | null) {
  return useQuery({
    queryKey: serviceKeys.detail(id ?? ''),
    queryFn: () => getServiceById(id!),
    enabled: !!id,
  });
}
